import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {EMPTY, Observable, of} from 'rxjs';
import { map, mergeMap, catchError,switchMap } from 'rxjs/operators';
import { AgencysService } from '../agencys.service';
import * as AgencyActions from './agencys.actions';
import {LOAD_AGENCYS} from "./agencys.actions";
import * as AcccountActions from "../../accounts/store/accounts.actions";

@Injectable()
export class AgencyEffects {

  getAgencys$ = createEffect(() => this.actions$.pipe(
      ofType(AgencyActions.LOAD_AGENCYS),

      mergeMap((payload:string) => this.agencysService.getAgencys(payload['payload'])
        .pipe(
          map(agencys => (console.log('fdgsfgsfgsdfgsfdgsfgsdfg',payload),{ type: AgencyActions.GET_AGENCYS, payload: agencys })),
          //map(accounts => (console.log('fdgsfgsfgsdfgsfdgsfgsdfg',payload),{ type: AcccountActions.ADD_ACCOUNTS, payload: accounts })),
          catchError((error) => {
            console.log('error',error);
            return of({ type: AcccountActions.LOAD_ACCOUNT_ERROR, payload: error });
          })
        ))
    ) //end outer pipe s
  );



  constructor(
    private actions$: Actions,
    private agencysService: AgencysService
  ) {}
}
